'use client';

import { IconChevronLeft, IconChevronRight } from '@/components/icons';
import { useDictionary } from '@/components/providers';
import { cn } from '@/lib/utils/tw-merge';
import type { UiSliderNavigationProps } from './UiSlider.types';

const buttonClass = cn(
    'flex size-10 shrink-0 items-center justify-center rounded-full border border-hairline bg-page',
    'text-[color:var(--pg-arrow-stroke)] shadow-[0_2px_8px_rgba(15,23,40,0.10)]',
    '[transition:var(--transition-button)]',
    'hover:-translate-y-0.5 hover:border-hairline-3 hover:bg-surface-2 hover:shadow-[0_4px_16px_rgba(15,23,40,0.14)]',
    'active:scale-95 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40',
    'disabled:cursor-not-allowed disabled:opacity-40 disabled:shadow-none',
    'disabled:hover:translate-y-0 disabled:hover:border-hairline disabled:hover:bg-page disabled:hover:shadow-none',
    'cursor-pointer',
);

export function UiSliderNavigation({
    canScrollLeft,
    canScrollRight,
    onPrev,
    onNext,
    className,
}: UiSliderNavigationProps) {
    const { a11y } = useDictionary();

    return (
        <div className={cn('flex gap-2', className)}>
            <button
                type="button"
                aria-label={a11y.sliderPrevious}
                disabled={!canScrollLeft}
                onClick={onPrev}
                className={buttonClass}
            >
                <IconChevronLeft className="size-4" />
            </button>
            <button
                type="button"
                aria-label={a11y.sliderNext}
                disabled={!canScrollRight}
                onClick={onNext}
                className={buttonClass}
            >
                <IconChevronRight className="size-4" />
            </button>
        </div>
    );
}
